import PodcastEpisodesTable from './PodcastEpisodesTable';

export default PodcastEpisodesTable;
